export const formStepperIconStyles = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const stepperStyles = {
  "& .MuiStepConnector-root": {
    display: "none",
  },

  "& .MuiStepContent-root": {
    borderLeft: "none",
    pl: 0,
    ml: 0,
  },

  "& .MuiStepLabel-label.Mui-disabled": {
    color: "text.primary",
  },

  "& .MuiStepLabel-iconContainer": {
    alignSelf: "start",
    pr: 1.5,
  },
  "& .MuiStepLabel-iconContainer .custom-icon": {
    bgcolor: "#FFF0E6",
    border: "1px solid #FFD7BA",
    color: "primary.main",
  },

  "& .MuiStepLabel-iconContainer.Mui-active .custom-icon": {
    bgcolor: "primary.main",
    color: "white",
  },

  "& .MuiStepLabel-iconContainer.Mui-completed .custom-icon": {
    bgcolor: "primary.main",
    color: "white",
  },
};

export const editButtonMdStyles = {
  display: { xs: "none", md: "flex" },
  minWidth: { md: 90, lg: 142 },
};

export const editButtonSmStyles = { display: { xs: "flex", md: "none" } };
